import { Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { useStateValue } from "../../../../../contextAPI/StateProvider";
import { RegisterFormDiv } from "../../Register.style";
import ZaiaButton from "../../../../zaiaComponents/zaiaButton";
import CheckBoxGroup from "../CheckBoxGroup";
import Header from "../Header";
import ProgressBar from "../ProgressBar";
import { StepFiveDiv } from "./style";
import { useTranslation } from "react-i18next";

function StepSeven({ activeStep, setActiveStep }) {
  const [t] = useTranslation("global");
  const [other, setOther] = useState("");
  const [, dispatch] = useStateValue();
  const handleNext = (values, { setSubmitting, resetForm }) => {
    dispatch({
      type: "SET_STEPSEVEN",
      stepSeven: values,
    });
    resetForm();
    setSubmitting(false);
    setActiveStep(0);
  };

  const checkBoxOptions3 = [
    { key: `${t("register.clinic")}`, value: "clinicas" },
    { key: `${t("register.quirurgicas")}`, value: "quirurgicas" },
    { key: `${t("register.science")}`, value: "ciencias basicas" },
    { key: `${t("register.investigacion")}`, value: "investigacion" },
    {
      key: `${t("register.gerencial")}`,
      value: "area gerencia/administrativa",
    },
    { key: `${t("register.salud")}`, value: "salud publica" },
    { key: `${t("register.other")}`, value: "other" },
  ];

  return (
    <Formik
      initialValues={{
        checkBoxOption3: [],
      }}
      validationSchema={Yup.object({
        checkBoxOption3: Yup.array(),
      })}
      onSubmit={handleNext}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          {activeStep === 100 && (
            <>
              <Header stepSeven setActiveStep={setActiveStep} />
              <ProgressBar done={activeStep} />
              <RegisterFormDiv>
                <StepFiveDiv>
                  <h3 className="title-register">
                    {t("register.experience")}:
                  </h3>
                  <p className="registerForm__subtitle">
                    {t("register.select")}
                  </p>
                  <CheckBoxGroup
                    name="checkBoxOption3"
                    options={checkBoxOptions3}
                  />
                  <input
                    className="stepFiveDiv__input"
                    type="text"
                    value={other}
                    onChange={(e) => setOther(e.target.value)}
                    placeholder={t("register.others")}
                  />
                  <ZaiaButton
                    type="submit"
                    marginTop="5"
                    title={
                      props.isSubmitting
                        ? "Loading ..."
                        : `${t("register.continue")}`
                    }
                  />
                </StepFiveDiv>
              </RegisterFormDiv>
            </>
          )}
        </form>
      )}
    </Formik>
  );
}

export default StepSeven;
